export function splitFilename(filename) {
  const sections = filename.split('.')
  if (sections.length <= 1) return [filename, '']

  const extension = '.' + sections.pop()
  const cleanFilename = sections.join('.')
  return [cleanFilename, extension]
}

export function formatDate(dateString) {
  const date = new Date(dateString)

  return date.toLocaleString('en-US', {
    timeZoneName: 'short',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    year: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}
